import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { Inject, isDevMode, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AssetPathResolverService, ContentService, CwpNgFrameworkModule, HrefResolverService, ServicePathProviderService } from '@blk/cwp-ng-framework';
import { UrlUtils } from '@ddt-web/url';

import { BaseHrefRetrieverService } from './base-href-retriever.service';
import { BootstrapOptions } from './bootstrap-options.interface';

// eslint-disable-next-line
declare let __webpack_public_path__: any;

export function GET_APP_BASE_HREF(baseHrefRetrieverService: BaseHrefRetrieverService): string {
	return baseHrefRetrieverService && baseHrefRetrieverService.getBaseHref();
}

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		RouterModule
	]
})
export class AppBootstrapModule {

	constructor(
		private hrefResolver: HrefResolverService,
		private assetPathService: AssetPathResolverService,
		private servicePathProvider: ServicePathProviderService,
		private contentService: ContentService,
		@Inject('environment') private environment: any,
		@Inject('options') private options: BootstrapOptions,
		@Optional() @SkipSelf() parentModule: AppBootstrapModule
	) {
		if (parentModule) {
			const moduleName = parentModule.constructor.name;
			throw new Error(`${moduleName} has already been loaded. Import ${moduleName} module in the AppModule only.`);
		}

		const isLocalDev = isDevMode();
		const isInternalHost = UrlUtils.isInternalHost();
		const blkGlobal: any = window['BLK'];
		if (blkGlobal !== undefined && !isLocalDev && !isInternalHost) {
			this.servicePathProvider.setServiceMap(blkGlobal.providedServiceMap);
			this.assetPathService.setPath(blkGlobal.assetPathPrefix);
			this.hrefResolver.setUrlMap(blkGlobal.urlMap);
		} else {
			this.servicePathProvider.setServiceMap(this.environment['providedServiceMap']);
			this.assetPathService.setPath(this.environment['assetPathPrefix']);
			this.hrefResolver.setUrlMap(this.environment['urlMap']);
		}

		if (this.environment?.dcr) {
			// This takes in content from environment file but overrides them from the input[hidden] field, which comes from index.html or teamsite
			const dcrCombined = Object.assign({}, this.environment?.dcr ?? {}, this.contentService['_dcrContent']);
			this.contentService.initialiseDCRContentFromObj(dcrCombined);
		}

		if (this.options.isLazyLoad) {
			const modulePath = `${this.assetPathService.getPath('')}/`;
			__webpack_public_path__ = modulePath;
		}
	}

	public static forRoot(environment: any, bootstrapComponents: any, options?: BootstrapOptions): ModuleWithProviders<AppBootstrapModule> {
		return {
			ngModule: AppBootstrapModule,
			providers: [
				{ provide: 'environment', useValue: environment },
				{ provide: 'bootstrapComponents', useValue: bootstrapComponents },
				{ provide: 'options', useValue: options ? options : {} },
				{
					provide: APP_BASE_HREF,
					deps: [BaseHrefRetrieverService],
					useFactory: GET_APP_BASE_HREF
				}
			]
		};
	}


}
